import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { CreateCaseQueryResponse } from "../../global/Types";
import { GetMockCaseQueryResponseList } from "../../mock/case-query-response/CaseQueryResponseList";
import { GetMockCaseQueryResponseRead } from "../../mock/case-query-response/CaseQueryResponseRead";

export const useCaseQueryResponseDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const GetCaseQueryResponse = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseQueryResponseRead());
      } else {
        globalFunctions
          .CallPortalApi("CaseQueryResponse/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetCaseQueryResponseList = (id: number, incDeleted: boolean) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseQueryResponseList());
      } else {
        globalFunctions
          .CallPortalApi("CaseQueryResponse/List", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
              IncludeDeleted: incDeleted,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const CreateCaseQueryResponse = (
    caseQueryResponse: CreateCaseQueryResponse
  ) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseQueryResponseList());
      } else {
        globalFunctions
          .CallPortalApi("CaseQueryResponse/Create", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify(caseQueryResponse),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  return {
    GetCaseQueryResponse,
    GetCaseQueryResponseList,
    CreateCaseQueryResponse,
  };
};
